module.exports = __webpack_public_path__ + "static/media/water-drop.ed9f8a0e.svg";